import React, { useEffect, useState } from "react";
import { Formik, Form, Field } from "formik";
import isGHMC, { getCurrentDate, getCurrentDateTime, getStartOfCurrentDate } from "../../../../Common/helper/helpar";
import { useAttendanceStore } from "./store/useAttendanceStore";
import useAttendanceFilterStore from "./store/useAttendanceFilterStore";
import { ExportAttendanceSummaryReport } from "../AttendanceSummaryReport/ExportsAttendanceSummary/ExportAttendanceSummaryReport";
import { getNowDateTime, getOneMonthPastDate, getOneMonthPastDateTime, getTodayDate } from "../../../AssetVehicle/utils/helpers";

export const AttendanceFilterForm = () => {
  const { fetchAttendanceReport } = useAttendanceStore();
  const { fetchFilterZones, zones, filters, resetFilters } = useAttendanceFilterStore();
  const isProd = isGHMC();
  const currentDate = getCurrentDate();
  const currentDateTime = getCurrentDateTime();
  const currentDateStartTime = getStartOfCurrentDate();

  const Filters = JSON.parse(localStorage.getItem("attendance-summary-filters"));

  useEffect(() => {
    fetchFilterZones();
  }, []);

  // Fetch attendance data when filters update
  useEffect(() => {
    if (!Filters) {
      localStorage.setItem("attendance-summary-filters", JSON.stringify(initialFilters));
    }
    fetchAttendanceReport(initialFilters);
  }, [filters]);

  const initialFilters = {
    fromDate: Filters ? Filters.fromDate : currentDate,
    toDate: Filters ? Filters.toDate : currentDate,
    // zoneId: Filters ? Filters.zoneId : "",
  }

  const handleSubmit = (values) => {
    localStorage.setItem("attendance-summary-filters", JSON.stringify(values));
    fetchAttendanceReport(values);
  };

  const handleReset = (resetForm) => {
    resetFilters();
    resetForm({
      values: {
        fromDate: currentDate,
        toDate: currentDate,
        zoneId: "",
      },
    });
    fetchAttendanceReport({
      fromDate: currentDate,
      toDate: currentDate,
      zoneId: "",
    });
    localStorage.removeItem("attendance-summary-filters");
  };

  return (
    <div>
      <Formik
        key={JSON.stringify(filters)}
        enableReinitialize
        initialValues={initialFilters}

        onSubmit={handleSubmit}
      >
        {({ values, resetForm }) => (
          <Form>
            <div className="row d-flex align-items-center">
              <div className="col-md-2 mb-3">
                <label className="form-label w-100 text-left">From Date</label>
                <Field
                  type="date"
                  name="fromDate"
                  className="form-control"
                  min={getOneMonthPastDate()}
                  max={getTodayDate()}
                  required
                />
              </div>
              <div className="col-md-2 mb-3">
                <label className="form-label w-100 text-left">To Date</label>
                <Field
                  type="date"
                  name="toDate"
                  className="form-control"
                  min={values.fromDate}
                  max={currentDate}
                />
              </div>
              <div className="col-md-2 mb-3">
                <label className="form-label w-100 text-left">Zone</label>
                <Field as="select" name="zoneId" className="form-select">
                  <option value="">Select Zone</option>
                  {zones.map((zone) => (
                    <option key={zone.zoneId} value={zone.zoneId}>
                      {zone.zoneName}
                    </option>
                  ))}
                </Field>
              </div>

              <div className="col-md-4 d-flex gap-2 align-items-end mt-3">
                <button
                  type="submit"
                  className={`btn ${isProd ? "report-search-ghmc" : "report-search-swm"} rounded-5`}
                >
                  Search
                </button>
                <button
                  type="reset"
                  className={`btn ${isProd ? "report-search-ghmc" : "report-search-swm"} rounded-5`}
                  onClick={() => handleReset(resetForm)}
                >
                  Reset
                </button>
                <ExportAttendanceSummaryReport />
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};
